export function aplicarMascaraOnlyNumbers(v: string) {
  v = v.replace(/\D/g, "");
  return v;
}
